<template>
  <product-management state="" />
</template>
<script>
export default {
  components: {
    productManagement: () => import('../productManagement/index.vue')
  }
}
</script>